import { API_KEYS, Api } from '../base.api';
import { PromoCodeApplyResponse, PromoCodeApplyPayload } from './promo-code-api.interface';

export interface ApplyPromoCodeRequest {
  sessionId: string;
  payload: PromoCodeApplyPayload;
}

export const promoCodeApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    applyPromoCode: builder.mutation<PromoCodeApplyResponse, ApplyPromoCodeRequest>({
      query: ({ sessionId, payload }: ApplyPromoCodeRequest) => ({
        url: `/core/v1/${API_KEYS.SESSIONS}/${sessionId}/apply-promo-code`,
        body: payload,
        method: 'POST',
      }),
      invalidatesTags: (result, error, arg) => [
        { type: API_KEYS.SESSIONS, id: arg.sessionId },
        { type: API_KEYS.CHARGERS, id: 'LIST' },
      ],
    }),
  }),
});

export const { useApplyPromoCodeMutation } = promoCodeApi;
